<div class="main-content">
	<div class="col-md-12">
		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">

				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='All Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='All Customers'}">
					<app-all-customers (viewData)="toggleFlipTest($event)"></app-all-customers>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Customers Online', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Customers Online'}">
					<app-customers-online (viewData)="toggleFlipTest($event)"></app-customers-online>
				</div>

				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Customer Carts', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Customer Carts'}" @grow>
					<app-customer-carts (viewData)="toggleFlipTest($event)"></app-customer-carts>
				</div>
				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='agedc', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='agedc'}" @grow>
					<app-over-due-customers (viewData)="toggleFlipTest($event)"></app-over-due-customers>
				</div>
				<div *ngIf="config && config.arpreauth && pendingAuthsDashboardSlot" class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Pending Auths', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Pending Auths'}" @grow>
					<app-pending-auths (viewData)="toggleFlipTest($event)" (dashboardSlotActive)="onPendingAuthsDashboardSlot($event)"></app-pending-auths>
				</div>
				<div *ngIf="config && config.arhold" class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='On Hold Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='On Hold Customers'}" @grow>
					<app-on-hold-customers (viewData)="toggleFlipTest($event)"></app-on-hold-customers>
				</div>
				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Inactive Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Inactive Customers'}" @grow>
					<app-customer-inactive (viewData)="toggleFlipTest($event)"></app-customer-inactive>
				</div>
				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Web Disabled Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Web Disabled Customers'}" @grow>
					<app-disabled-customers (viewData)="toggleFlipTest($event)"></app-disabled-customers>
				</div>
				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='OOB Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='OOB Customers'}" @grow>
					<app-oob-customers (viewData)="toggleFlipTest($event)"></app-oob-customers>
				</div>

				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Open Quotes', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Open Quotes'}" @grow *ngIf="config.env.package == 'beauty' && !user.user.issalesman || config.env.package == 'tires'">
					<app-customer-open-quotes (viewData)="toggleFlipTest($event)"></app-customer-open-quotes>
				</div>
				<div
				  [ngClass]="{
					'col-lg-4 col-md-4 col-sm-6': viewing_title != 'Top 100 Customers',
					'col-lg-12 col-md-12 col-sm-12': viewing_title == 'Top 100 Customers'
				  }"
				  @grow
				>
				  <!-- NEW: Top Customers Component -->
				  <app-top-customers (viewData)="toggleFlipTest($event)"></app-top-customers>
				</div>
				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='New Customers', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='New Customers'}" @grow>
					<app-new-customers (viewData)="toggleFlipTest($event)"></app-new-customers>
				</div>




				<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Matching Receivables', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Matching Receivables'}" @grow *ngIf="editsallowed.editar && !user.user.issalesman">
					<app-matching-docs (viewData)="toggleFlipTest($event)"></app-matching-docs>
				</div>
				<ng-container *ngIf="config.env.package == 'tires'">
					<div class="" [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Matching National Account Receivables', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Matching National Account Receivables'}" @grow>
						<app-matching-doc-customer-type (viewData)="toggleFlipTest($event)"></app-matching-doc-customer-type>
					</div>
				</ng-container>


				<div class="row tp-box__side tp-box__back">
					<div class="cw-wrap w-100" [ngStyle]="themeVars">
						<div class="cw-icon-badge pointer" (click)="toggleFlip('')" title="Back to dashboard">
							<i class="material-icons">groups</i>
						</div>
						<div class="cw-header">
							<div class="cw-title-group">
								<button class="cw-back-btn" (click)="toggleFlip('')" title="Back to dashboard">
									<i class="material-icons">arrow_back_ios</i>
									<span>Dashboard</span>
								</button>
								<span class="cw-title">{{ viewing }}</span>
							</div>
						</div>
						<div class="cw-body">
							<div class="results mt-2 mb-2">
								<ng-container [ngSwitch]="viewing">
									<app-customer-carts *ngSwitchCase="'Customer Carts'" [data]="currentcarts"></app-customer-carts>
									<app-customer-carts *ngSwitchCase="'Customer Carts One'" [data]="cartagebuckets[2]"></app-customer-carts>
									<app-customer-carts *ngSwitchCase="'Customer Carts Two'" [data]="cartagebuckets[3]"></app-customer-carts>
									<ng-container *ngSwitchCase="'On Hold Customers'">
										<div class="table-responsive" *ngIf="viewing_data && viewing_data.length">
											<table class="table table-sm">
												<thead><tr><th>Customer</th><th>Reason</th><th class="text-right">Balance</th></tr></thead>
												<tbody>
													<tr *ngFor="let c of viewing_data"><td>{{ c.name || c.debtorno }}</td><td>{{ c.reasondescription || 'On hold' }}</td><td class="text-right">{{ c.balance | currency }}</td></tr>
												</tbody>
											</table>
										</div>
										<p class="text-muted mb-0" *ngIf="!viewing_data || !viewing_data.length">No customers on hold.</p>
									</ng-container>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
